module.exports = __webpack_public_path__ + "img/483-467f91.png";